import { HelperResult, UserProfessionalExperience } from '@openclassrooms/sdk-web/src';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';
import { UseFindFilters } from '../../utils/services/getUseFind';

interface CreateProfessionalExperiencesParams {
  userId: number;
  context?: string;
}

const {
  useCreate: useCreateProfessionalExperience,
  useGet: useProfessionalExperience,
  useUpdate: useUpdateProfessionalExperience,
  useFind: useFindProfessionalExperiences,
  useDelete: useDeleteProfessionalExperience,
} = getCRUDHooks<UserProfessionalExperience>({
  entityName: 'professionalExperiences',
  create: (
    values: UserProfessionalExperience,
    { userId, context }: CreateProfessionalExperiencesParams
  ) =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .professionalExperiences.create(values, false)
      .setHeader('X-Request-Context', context)
      .execute(),
  get: ({
    userId,
    professionalExperienceId,
  }: {
    userId: number;
    professionalExperienceId: number;
  }) =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .professionalExperiences.get(professionalExperienceId),
  find: ({ userId, filters }: { userId: number; filters: UseFindFilters }) =>
    clientApi.getOCClient().helpers.user.users.id(userId).professionalExperiences.find(filters),
  update: (
    values: Partial<UserProfessionalExperience>,
    {
      userId,
      professionalExperienceId,
      context,
    }: { userId: number; professionalExperienceId: number; context: string }
  ): HelperResult<UserProfessionalExperience> =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .professionalExperiences.partialUpdate(professionalExperienceId, values, false)
      .setHeader('X-Request-Context', context)
      .execute(),
  remove: ({ userId, id }: { userId: number; id: number }) =>
    clientApi.getOCClient().helpers.user.users.id(userId).professionalExperiences.delete(id),
});

export {
  useCreateProfessionalExperience,
  useProfessionalExperience,
  useUpdateProfessionalExperience,
  useFindProfessionalExperiences,
  useDeleteProfessionalExperience,
};
